import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  AddEmissionContext,
  EmissionMode,
} from "../../../../../../contexts/AddEmissionContext";
import { common, input } from "../../../../../../i18n";
import { NumericField } from "../../../../../../components/input/NumericField";

interface Props {
  label: string;
  info: string;
  control: Control<any, any>;
  endIcon?: JSX.Element;
  disabled?: boolean;
}

export const AmountInput = (props: Props) => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const { emissionMode, isDisabledAuxInput } = AddEmissionContext();
  AddEmissionContext();

  return (
    <>
      <NumericField
        key="amount"
        required={emissionMode === EmissionMode.AddEmission ? true : false}
        size="small"
        name="amount"
        control={props.control}
        allowNegative={false}
        decimalScale={4}
        label={t(props.label)}
        info={t(props.label) === t(props.info) ? undefined : t(props.info)}
        fullWidth
        disabled={isDisabledAuxInput || props.disabled ? true : false}
        placeholder="0.0000"
      />
    </>
  );
};
